export enum ProgressPercent {
  Warning = 80,
  Critical = 95,
}
